import React from 'react'
import {bool, node, oneOf} from 'prop-types'
import classNames from 'classnames'
import {NotificationBox} from '@agillic/agillic-ui'

const Notification = ({isVisible, children, type, hasMessage, hasSmallerMargin}) => (isVisible && (
  <div className={classNames({message: hasMessage, smallerMargin: hasSmallerMargin})}>
    <NotificationBox type={type}>
      {children}
    </NotificationBox>
  </div>
))

Notification.propTypes = {
  isVisible: bool,
  children: node,
  type: oneOf(['info', 'important', 'error']),
  hasMessage: bool,
  hasSmallerMargin: bool
}

export default Notification
